import type { Employee, FullNameEmployee } from '@/types/employee';
import type { NameIdPair } from '@/types/nameIdPair';

export function getEmployeeId(employeeOrEmployeeId: string | Employee): string {
    return typeof employeeOrEmployeeId === 'string' ? employeeOrEmployeeId : employeeOrEmployeeId?._id;
}

/**
 * Converts list of items to only NameIdPair objects based on `item.fullName`.
 * Hereby also stripping unneeded data.
 */
export function fullNameIdPairsToNameIdPairs(items: FullNameEmployee[]): NameIdPair[] {
    return items.map((item) => ({ _id: item._id, name: item.fullName }));
}
